import React from "react";
import PropertyCard from "./PropertyCard";

const properties = [
  {
    image: "https://via.placeholder.com/300x200", // Replace with actual image
    title: "Ozaki House",
    location: "HSR 6th Sector, Bangalore",
    distance: "9.1km",
    price: "6,196",
    gender: "Male" as "Male",
    rating: "4.9",
  },
  {
    image: "https://via.placeholder.com/300x200", // Replace with actual image
    title: "Ozaki House",
    location: "HSR 6th Sector, Bangalore",
    distance: "9.1km",
    price: "6,196",
    gender: "Female" as "Female",
    rating: "4.9",
  },
  {
    image: "https://via.placeholder.com/300x200", // Replace with actual image
    title: "Ozaki House",
    location: "HSR 6th Sector, Bangalore",
    distance: "9.1km",
    price: "6,196",
    gender: "Female" as "Female",
    rating: "4.9",
  },
];

const PropertiesList = ({data}:any) => {
  return (
    <div className="container mx-auto px-4 mb-10">
      {/* <h2 className="text-2xl font-semibold mb-6">Other Similar Properties</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {properties.map((property, index) => (
          <PropertyCard key={index} {...property} />
        ))}
      </div> */}
    </div>
  );
};

export default PropertiesList;
